<template lang="pug">
li.omnesMedium.item(@click="checkItem" :class="{'selected': scoreVal === scoreItem.id}")
  | {{ scoreItem.id }}
</template>

<script>
export default {
  props: [
    'scoreVal',
    'scoreItem'
  ],
  methods: {
    checkItem () {
      this.$emit('select', this.scoreItem.id)
    }
  }
}
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/modals/nps/PopupNpsList.vue